<div class="sdp-wizard-hide-wizard">
	<div
		class="sdp-wizard-hide-wizard-spinner"
		*ngIf="isHideWizardChanging"
	>
		<mat-spinner diameter="19"></mat-spinner>
	</div>
	<p-checkbox
		[disabled]="isHideWizardChanging"
		name="hideWizardCB"
		binary="true"
		[(ngModel)]="hideWizard"
		(onChange)="toggleHideWizard()"
		label="{{ 'user.wizard.hide.wizard' | translate }}"
	></p-checkbox>
</div>